import { jsx as _jsx } from "react/jsx-runtime";
import { usePageContext } from 'src/hooks';
import { DealsStorefrontPage } from './dealsStorefrontPage';
import { RegularStorefrontPage } from './regularStorefrontPage';
export const StorefrontPage = () => {
    const { storefront } = usePageContext();
    if (storefront.meta.type === 'DEALS') {
        return _jsx(DealsStorefrontPage, {});
    }
    return _jsx(RegularStorefrontPage, {});
};
